import Any from './properties/Any/regex.mjs';
import Cc  from './categories/Cc/regex.mjs';
import Cf  from './categories/Cf/regex.mjs';
import P   from './categories/P/regex.mjs';
import Z   from './categories/Z/regex.mjs';

export { Any, Cc, Cf, P, Z };
